import moment from "moment";

export const validatePhoneNumber = (t) => async (_, value) => {
    const phoneNumberPattern = /^\+213\d{9}$/;

    if (!phoneNumberPattern.test(value)) {
        return Promise.reject(t("employees.crud.form.error.format.phoneNumber"));
    }

    return Promise.resolve();
};

export const validateImageFile = async (_, value) => {
    if (!value || value.length === 0) {
        return Promise.resolve();
    }

    const file = value[0].originFileObj;
    if (file) {
        // Vérifier que le fichier est une image
        if (!file.type.startsWith("image/")) {
            return Promise.reject(new Error("Le fichier doit être une image"));
        }

        // Vérifier l'extension du fichier
        const allowedExtensions = ["jpg", "jpeg", "png"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            return Promise.reject(
                new Error("Seules les images JPG, JPEG et PNG sont autorisées")
            );
        }
    }

    return Promise.resolve();
};



export const validateBirthDate = async (_, value) => {
    if (value && value.isAfter(moment())) {
        return Promise.reject(
            new Error("La date de naissance ne peut pas être dans le futur")
        );
    }
    return Promise.resolve();
};
export const validateNIF = async (_, value) => {
    // Si aucune valeur, la règle "required" gère l'erreur.
    if (!value) {
        return Promise.resolve();
    }

    const length = value.toString().length;
    const maxInt = 2147483647; // Limite maximale d'un integer 32 bits

    if (length < 9) {
        return Promise.reject(new Error("Le NIF doit contenir au moins 9 chiffres"));
    }

    if (value > maxInt) {
        return Promise.reject(new Error(`Le NIF ne doit pas dépasser ${maxInt}`));
    }

    return Promise.resolve();
};
